import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import classNames from 'classnames'

import { DocStatusTypes } from '@slite/editor'
import { selectors as UISelectors } from 'data/ui'
import { incrementMetric } from 'data/metrics'

import { PrimaryAction } from 'components/base/Text'
import { WarningIcon } from 'components/Utils/Icons'
import { CloudStrikeThroughIcon } from 'components/Utils/Icons'
import ChangeLayoutConfiguration from './ChangeLayoutConfiguration'

import { NOTE_HEADER_HEIGHT } from 'components/Layout/NoteView'

const { DISCONNECTED } = UISelectors.CONNECTION_STATUSES_TYPE
const { DOC_STATUS_ERROR } = DocStatusTypes

const NoteHeader = ({ collabConnectionStatus, docStatus, note, track }) => {
  const noConnection = collabConnectionStatus === DISCONNECTED
  const hasEditorError = docStatus === DOC_STATUS_ERROR
  const hasErrors = noConnection || hasEditorError
  useEffect(
    () => {
      if (hasEditorError) {
        track('SEEN_EDITOR_ERROR_BANNER')
        incrementMetric({ name: 'crash', service: 'editor' })
      }
    },
    [hasEditorError, track]
  )

  return (
    <div
      className={classNames({
        'zindex-small': hasErrors,
      })}
    >
      {!hasErrors && Boolean(note) && <ChangeLayoutConfiguration />}
      {noConnection && (
        <div
          style={{
            height: NOTE_HEADER_HEIGHT,
          }}
          className="flexbox flexbox-centered flexbox-wrap center-text font-weight-medium font-size-large background-primary-shade-dark shade-05"
        >
          <CloudStrikeThroughIcon
            size={16}
            className="margin-right-small primary-shade-light"
          />
          You've been disconnected. We'll keep trying to reconnect.
        </div>
      )}
      {hasEditorError && (
        <div
          style={{ height: NOTE_HEADER_HEIGHT }}
          className="flexbox flexbox-centered flexbox-wrap center-text background-primary-shade-dark shade-05 font-weight-medium font-size-large"
        >
          <WarningIcon
            size={16}
            className="margin-right-small primary-shade-light"
          />
          <div className="margin-right-smaller">
            Sorry, we’re having trouble displaying your document correctly,
          </div>
          <PrimaryAction
            className="inline-block font-weight-medium font-size-large"
            onClick={() => window.location.reload()}
          >
            please refresh.
          </PrimaryAction>
        </div>
      )}
    </div>
  )
}

NoteHeader.propTypes = {
  collabConnectionStatus: PropTypes.string,
  noteId: PropTypes.string.isRequired,
}

export default NoteHeader
